// extracted by mini-css-extract-plugin
export default {"scoreDisplay":"Pvi1nKJ4","mobile":"mobile","scoreValue":"UHgmAniY","starWrapper":"XcX1nMZX","stars":"OD_XA8BZ","starHalf":"WNANWsYd","star":"DMkt8EUp"};